/* eslint-disable */
import moment from 'moment'
import state from 'src/store/state'
const staging = window.location.hostname === 'magazine-staging.qingmang.mobi' // || process.env.NODE_ENV === 'development'
const imageBeforeBind = 'http://statics01.readland.cn/12e584bc5efd.jpg'
/**
 * cookie
 */
export function getCookie(name) {
  let arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if ((arr = document.cookie.match(reg))) {
    return arr[2]
  } else {
    return null
  }
}

export function setCookie(key, value, expiredays, domain) {
  let exdate = new Date()
  let path = '/'
  // const domain = '.qingmang.mobi'
  domain = domain || window.location.hostname
  // const domain = window.location.protocol + '//' + window.location.host
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie =
    key +
    '=' +
    escape(value) +
    (expiredays == null ? '' : ';expires=' + exdate.toGMTString()) +
    (path ? ';path=' + path : '') +
    (domain ? ';domain=' + domain : '')
}

/**
 * debug log
 */
export const log =
  process.env.NODE_ENV === 'development'
    ? console.log.bind(console)
    : () => undefined

/**
 * 从 url 里面取 param
 * @param paramName
 * @returns {string}
 */
export function getParam(paramName) {
  if (location.href.split('?')[1] !== undefined) {
    let a = location.href.split('?')[1].split('&')
    for (let i = 0; i < a.length; i++) {
      if (a[i].split('=')[0] === paramName) {
        return a[i].split('=')[1]
      }
    }
  }
  return ''
}

/**
 * 深拷贝
 * @param obj
 * @returns {any}
 */
export const deepCopy = function (obj) {
  let str
  let newObj = obj.constructor === Array ? [] : {}
  if (typeof obj !== 'object') {
    return undefined
  } else if (window.JSON) {
    str = JSON.stringify(obj) //系列化对象
    newObj = JSON.parse(str) //还原
  } else {
    for (let i in obj) {
      newObj[i] = typeof obj[i] === 'object' ? newObj(obj[i]) : obj[i]
    }
  }
  return newObj
}

/**
 * 深层 merge，用来处理 app.json 的合并
 * @param target
 * @param source
 * @returns {Object}
 */
export const mergeDeep = (target, source) => {
  let output = { ...target }

  if (isObject(target) && isObject(source)) {
    Object.keys(source).map(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] })
        } else {
          output[key] = mergeDeep(target[key], source[key])
        }
      } else {
        Object.assign(output, { [key]: source[key] })
      }
    })
  }

  return output
}

/**
 * 获取 10 位以内的随机唯一码
 * @returns {string}
 */
export const generateRandomNumber = function () {
  let now = new Date()
    .getTime()
    .toString()
    .substring(7, 13)
  const random = (Math.random().toFixed(3) * 1000).toString()
  if (now.startsWith('0')) {
    now = '1' + now
  }
  return (now + random).substring(0, 8)
}

/**
 * 读取用户的 token 信息，如果没有登录，则返回 null.
 */
export function getUserToken() {
  if (process.env.NODE_ENV === 'development') {
    // return 'MTViN2RkMjItNDU4Zi0xMWU5LTlmNGQtMDAxNjNlMDM2OTg5' // 未登录
    // return 'MGVmNjY3MDAtNjhhMC0xMWU4LWJkNjAtMDAxNjNlMzI2OTg3' // 云天喵
    // return 'ZWU4MGI1NWEtNTJiNy0xMWU4LWIwMTYtMDAxNjNlMzI2OTg3' // ADMIN
    // return 'MGI0ZDVhOWMtMjk5ZS0xMWU3LWFhNTAtMDAxNjNlMzI2OTg3' // 范老师
    // return "N2JkZDZkNjQtNzU2ZC0xMWU2LTgyZDMtMDAxNjNlMDAyYjlm" // guoronghua
    // return 'M2IyMTk0MzAtN2QwNS0xMWU3LWE1M2QtMDAxNjNlMDM2OTg5' // 发布哥
    // return 'M2Q5OTllODItNzViMy0xMWU3LTlmYTUtMDAxNjNlMzI2OTg3' // 祥林
  }
  return getCookie('qingmang')
}

/**
 * 获取每日数据所需的 YYYY-MM-DD 格式的日期字符串
 * @param {number} [ts]
 * @returns {string}
 */
export function getDailyDate(ts) {
  return ts
    ? moment(ts).format('YYYY-MM-DD')
    : moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD')
}

export function getDateTime(ts) {
  return ts
    ? moment(ts).format('YYYY-MM-DD HH:mm')
    : moment().format('YYYY-MM-DD HH:mm')
}

/**
 * 获取 24 小时之内的相对时间
 * 如果时间超过一天，则返回空
 * @param  {string} pastTimestamp
 * @return {string}
 */
export const getHoursAgoRelativeTime = pastTimestamp => {
  const nowTimestamp = new Date().getTime()
  const timestampDiff = nowTimestamp - pastTimestamp
  const maxDiff = 1000 * 60 * 60 * 24 // 一天

  if (timestampDiff >= maxDiff) {
    return null
  }

  return util.formatTime(pastTimestamp, true)
}

/**
 * 把一个时间戳（毫秒数），转成中文字符串，增加了空格
 */
export const getRelatedFormattedTime = function (
  timestamp,
  relativeTimestamp = true,
) {
  let currentDate = new Date()
  let current = currentDate.getTime()
  let diff = current - timestamp
  if (relativeTimestamp) {
    if (diff <= 60 * 1000) {
      return '刚刚'
    } else if (diff <= 60 * 60 * 1000) {
      return '' + Math.floor(diff / (60 * 1000)) + ' 分钟前'
    } else if (diff <= 24 * 60 * 60 * 1000) {
      return '' + Math.floor(diff / (60 * 60 * 1000)) + ' 小时前'
    } else if (diff <= 7 * 24 * 60 * 60 * 1000) {
      return '' + Math.floor(diff / (24 * 60 * 60 * 1000)) + ' 天前'
    }
  }
  let date = new Date(timestamp)
  let day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()

  // 如果是同一天，并且绝对时间戳
  if (
    !relativeTimestamp &&
    currentDate.getDate() === day &&
    currentDate.getMonth() + 1 === month &&
    currentDate.getFullYear() === year
  ) {
    let h = date.getHours() < 10 ? '0' + date.getHours() : '' + date.getHours()
    let m =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : '' + date.getMinutes()
    return h + ':' + m
  }
  if (year === currentDate.getFullYear()) {
    // 同一年.
    return '' + month + ' 月 ' + day + ' 日'
  }
  return '' + year + ' 年 ' + month + ' 月 ' + day + ' 日'
}

export function generateLibQrCode(libId, wxappId = 'wx3e0a5430ef91b0e8') {
  const HOST = 'http://statics03.qingmang.mobi/'
  const TYPE = 'wxacode'
  return `${HOST}mina/${TYPE}/lib/${wxappId}/${libId}`
}

export function generateLibSharePoster(libId, appId = 'wx3e0a5430ef91b0e8') {
  const HOST = 'http://statics03.qingmang.mobi/'
  const TYPE = 'share'
  const random = generateRandomNumber()
  return `${HOST}image2/${TYPE}/${appId}/lib/${libId}/s?ts=${random}`
}

export function hasQrCode(publicationInfo) {
  if (isAppOnly()) return false
  const { appInfo } = publicationInfo
  const hasRelease = appInfo && appInfo.versions && appInfo.versions.release
  const hasPreview = appInfo && appInfo.versions && appInfo.versions.preview
  return hasRelease || hasPreview
}

export function generateMagazineQrCode(magazineId, publicationInfo) {
  return generateMinaCodeForPublication('magazine', publicationInfo, { mid: magazineId })
}

export function generateMagazinePoster(
  magazineId,
  appId = 'wx05790b1180642960',
) {
  const HOST = 'http://statics03.qingmang.mobi'
  const TYPE = 'share'
  return `${HOST}/image2/${TYPE}/${appId}/magazine/${magazineId}/s`
}

export function generateArticleQrcode(
  magazineId,
  docId,
  appId = 'wx05790b1180642960',
) {
  const HOST = 'http://statics03.qingmang.mobi'
  const TYPE = 'wxacode'
  return `${HOST}/mina/${TYPE}/article/${appId}/${docId}__mid__${magazineId}`
}

export function generateArticlePath(magazineId, docId) {
  return `pages/explore/explore?target=/pages/article/article%3Fid%3D${docId}%26mid%3D${magazineId}`
}

export function generateArticlePoster(
  magazineId,
  docId,
  appId = 'wx05790b1180642960',
) {
  const HOST = 'http://statics03.qingmang.mobi'
  const TYPE = 'share'
  return `${HOST}/image2/${TYPE}/${appId}/article/${docId}/s/mid__${magazineId}`
}

/**
 * 初始化 intercom
 */
// export const initIntercom = function() {
//   const APP_ID = 't80j35ze'

//   ;(function() {
//     const w = window
//     const d = document
//     const ic = w.Intercom

//     function callback() {
//       const s = d.createElement('script')
//       s.type = 'text/javascript'
//       s.async = true
//       s.src = 'https://widget.intercom.io/widget/' + APP_ID
//       const x = d.getElementsByTagName('script')[0]
//       x.parentNode.insertBefore(s, x)
//     }

//     if (typeof ic === 'function') {
//       ic('reattach_activator')
//       ic('update', intercomSettings)
//     } else {
//       const i = function() {
//         i.c(arguments)
//       }
//       i.q = []
//       i.c = function(args) {
//         i.q.push(args)
//       }
//       w.Intercom = i
//       if (w.attachEvent) {
//         w.attachEvent('onload', callback)
//       } else {
//         w.addEventListener('load', callback, false)
//       }
//     }
//   })()
// }
/**
 * 初始化 GA
 */
export const initGA = function () {
  // For GA
  ; (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r
    i[r] =
      i[r] ||
      function () {
        ; (i[r].q = i[r].q || []).push(arguments)
      }
    i[r].l = 1 * new Date()
    a = s.createElement(o)
    m = s.getElementsByTagName(o)[0]
    a.async = 1
    a.src = g
    m.parentNode.insertBefore(a, m)
  })(
    window,
    document,
    'script',
    'https://www.google-analytics.com/analytics.js',
    'ga',
  )

  ga('create', 'UA-15790641-88', 'auto')
  ga('send', 'pageview')
}

/**
 * GA 埋点
 *
 * @param {*} category
 * @param {*} action
 * @param {*} label
 */
export function GA(category, action, label) {
  if (label === 'content') {
    label = 'index'
  }
  if (staging) {
    console.info('GA', category, action, label)
  }
  ga('send', 'event', {
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
  })
}

export function GAPageView(path) {
  let arr = path.split('/')
  if (arr[1] === 'content') {
    arr[1] = 'index'
  }
  path = arr.join('/')
  if (staging) {
    console.info('GA', path)
  }
  ga('send', 'pageview', path)
}

export function setGAUserId(userId) {
  ga('set', 'userId', userId)
}

/**
 * 一些验证
 */
export function validateURL(url) {
  const urlP = /^((https?|ftp|file):\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/
  return urlP.test(url)
}

export function isObject(item) {
  return (
    item && typeof item === 'object' && !Array.isArray(item) && item !== null
  )
}

export function isEmptyString(str) {
  return str.replace(/(^\s*)|(\s*$)/g, '').length === 0
}

export function isEmptyObject(object) {
  for (let x in object) {
    return false
  }

  return true
}

/**
 * 判断对象相等
 * @params a {Any}
 * @params b {Any}
 * @source: https://github.com/epoberezkin/fast-deep-equal
 */
export function deepEqual(a, b) {
  let isArray = Array.isArray
  let keyList = Object.keys
  let hasProp = Object.prototype.hasOwnProperty
  if (a === b) return true

  let arrA = isArray(a),
    arrB = isArray(b),
    i,
    length,
    key

  if (arrA && arrB) {
    length = a.length
    if (length != b.length) return false
    for (i = 0; i < length; i++) {
      if (!equal(a[i], b[i])) return false
    }
    return true
  }

  if (arrA != arrB) return false

  let dateA = a instanceof Date,
    dateB = b instanceof Date
  if (dateA != dateB) return false
  if (dateA && dateB) return a.getTime() == b.getTime()

  let regexpA = a instanceof RegExp,
    regexpB = b instanceof RegExp
  if (regexpA != regexpB) return false
  if (regexpA && regexpB) return a.toString() == b.toString()

  if (a instanceof Object && b instanceof Object) {
    let keys = keyList(a)
    length = keys.length

    if (length !== keyList(b).length) {
      return false
    }

    for (i = 0; i < length; i++) {
      if (!hasProp.call(b, keys[i])) return false
    }

    for (i = 0; i < length; i++) {
      key = keys[i]
      if (!equal(a[key], b[key])) return false
    }

    return true
  }

  return false
}

/**
 * 检查 obj 里面有没有 path 的 value
 * .has(obj, 'a.b.c')
 * @param obj
 * @param path
 * @returns {boolean}
 */
export function has(obj, path) {
  const r = get(obj, path)
  if (r === null || r === undefined) {
    return false
  } else {
    return true
  }
}

/**
 * 返回 obj 里 path 的 value ,没有则 null
 * .has(obj, 'a.b.c')
 * @param obj
 * @param path
 * @returns {object}
 */
export function get(obj, path) {
  path = path.replace(/\[(.+)\]\./, '.$1.')
  if (obj && path) {
    let arr = path.split('.')
    for (let k of arr) {
      if (obj && typeof obj === 'object' && k in obj) {
        obj = obj[k]
      } else {
        return null
      }
    }
    return obj
  }
  return null
}

// 是否为 BITC pub_id
export function isBITC() {
  const publicationId = state.route.params.publicationId || ''
  return [6950, 30072, 30693, 30717, 35103].some(e => e === Number(publicationId))
}

export function isKids() {
  const publicationId = Number(state.route.params.publicationId || '0')
  return [33575, 33481].indexOf(publicationId) >= 0
}

export function isQingmang() {
  const publicationId = Number(state.route.params.publicationId || '0')
  return [21689, 634].indexOf(publicationId) >= 0
}

export function isDayu() {
  const publicationId = Number(state.route.params.publicationId || '0')
  return [35409, 35667].indexOf(publicationId) >= 0
}

export function isDuku() {
  const publicationId = Number(state.route.params.publicationId || '0')
  return [35413].indexOf(publicationId) >= 0
}

export function isHalfday() {
  const publicationId = Number(state.route.params.publicationId || '0')
  return [35441].indexOf(publicationId) >= 0
}

export function isNewPublication() {
  return true
}

// dom 操作
export function animateScrollTo(element, speed) {
  let rect = element.getBoundingClientRect()
  //获取元素相对窗口的top值，此处应加上窗口本身的偏移
  let top = window.pageYOffset + rect.top - 20
  let currentTop = 0
  let requestId

  //采用requestAnimationFrame，平滑动画
  function step() {
    currentTop += speed
    if (currentTop <= top) {
      window.scrollTo(0, currentTop)
      requestId = window.requestAnimationFrame(step)
    } else {
      window.cancelAnimationFrame(requestId)
    }
  }

  window.requestAnimationFrame(step)
}

/**
 * 生成小程序的路径
 * @param path {String} 基准 path
 * @param params {{id: *}} 挂在 query 中的参数
 * @param [params.target] {Object} 用来跳转的 target 对象
 * @param params.target.params {Object} target 的参数
 * @param params.target.base {Object} target 的 path
 * @returns {string}
 */
export function buildUrl(path, params) {
  const buildParams = params => {
    return Object.entries(params)
      .map(keyValuePair => {
        const [key, value] = keyValuePair
        if (key === 'target') {
          return `${key}=${encodeURIComponent(
            `${value.base}?${buildParams(value.params)}`,
          )}`
        } else {
          return `${key}=${value}`
        }
      })
      .join('&')
  }
  return `${path}?${buildParams(params)}`
}

/**
 * 根据各类参数生成需要的小程序路径
 * @param pageType {String} values: ['player', 'page', 'magazine', 'post', 'article', 'quiz', 'lib']
 * @param parameters {Object} 参数列表
 * @param [parameters.publicationId] {Number}
 * @param [parameters.mid] {Number}
 * @param [parameters.docId] {String}
 * @param [parameters.libId] {Number}
 * @param [parameters.pageId] {Number}
 * @param [parameters.needBase = false] {Boolean} - 是否需要垫一层 Page/Explore
 * @param [parameters.isPrivate = false] {Boolean} - 是否私有小程序
 */
export function buildMinaUrl(pageType, parameters) {
  const {
    needBase,
    isPrivate,
    publicationId,
    mid,
    docId,
    pageId,
    libId,
    topicId,
    url,
  } = parameters
  const pathDict = {
    page: 'pages/page/page',
    explore: 'pages/explore/explore',
    magazine: 'pages/magazine/magazine',
    post: 'pages/post/post',
    article: 'pages/article/article',
    quiz: 'pages/quiz/list',
    lib: 'pages/quiz/lib',
    player: 'pages/music/music',
    topic: 'pages/group/group',
  }
  const dict = {
    page() {
      let target = {
        base: `/${pathDict.page}`,
        params: {
          id: pageId,
          c: getCampaign(),
        },
      }
      return buildUrl(pathDict.page, { publicationId, target })
    },
    magazine() {
      if (!needBase) {
        let path = pathDict.magazine
        let params = {
          id: mid,
          c: getCampaign(),
        }
        return buildUrl(path, params)
      } else {
        let params = {
          target: {
            base: `/${pathDict.magazine}`,
            params: {
              c: getCampaign(),
              id: mid,
            },
          },
          publicationId,
        }
        if (pageId) {
          params.id = pageId
        }
        // let path = isPrivate ? pathDict.page : pathDict.explore
        return buildUrl(pathDict.page, params)
      }
    },
    article() {
      if (!needBase) {
        return buildUrl(pathDict.article, {
          mid,
          id: docId,
          c: getCampaign(),
        })
      } else {
        let params = {
          target: {
            base: `/${pathDict.article}`,
            params: {
              mid: mid,
              id: docId,
              c: getCampaign(),
            },
          },
        }
        let path = isPrivate ? pathDict.page : pathDict.page
        if (isPrivate) {
          params = {
            publicationId,
            ...params,
          }
        }
        return buildUrl(path, params)
      }
    },
    quiz() {
      return buildUrl(pathDict.quiz, {
        publication: publicationId,
        c: getCampaign(),
      })
    },
    lib() {
      return buildUrl(pathDict.lib, {
        id: libId,
        c: getCampaign(),
      })
    },
    player() {
      let params
      if (needBase) {
        params = {
          target: {
            base: `/${pathDict.player}`,
            params: {
              autoPlay: 'true',
              mid: mid,
              docId: docId,
              c: getCampaign(),
            },
          },
        }
      } else {
        params = {
          autoPlay: 'true',
          mid: mid,
          docId: docId,
          c: getCampaign(),
        }
      }
      let path = needBase ? pathDict.page : pathDict.player
      if (!isPrivate) {
        params.publicationId = publicationId
      }
      return buildUrl(path, params)
    },
    topic() {
      if (!needBase) {
        let path = pathDict.topic
        let params = {
          id: topicId,
          publicationId,
          c: getCampaign(),
        }
        return buildUrl(path, params)
      } else {
        let params = {
          target: {
            base: `/${pathDict.topic}`,
            params: {
              c: getCampaign(),
              id: topicId,
            },
          },
          publicationId,
        }
        if (pageId) {
          params.id = pageId
        }
        // let path = isPrivate ? pathDict.page : pathDict.explore
        return buildUrl(pathDict.page, params)
      }
    },
    webUrl() {
      return url
    },
  }
  if (dict[pageType]) {
    return dict[pageType]()
  } else {
    return ''
  }
}

/**
 * 根据生成的小程序路径返回对应的 params
 * @param path {String}
 * @return {Object}
 */
export function parseMinaUrl(path) {
  const pathDict = {
    page: 'pages/page/page',
    explore: 'pages/explore/explore',
    magazine: 'pages/magazine/magazine',
    post: 'pages/post/post',
    article: 'pages/article/article',
    quiz: 'pages/quiz/list',
    lib: 'pages/quiz/lib',
    player: 'pages/music/music',
    topic: 'pages/group/group',
  }
  const wastedParams = ['c', 'autoPlay']
  function parseUrl(url) {
    let result = {}
    let [base, paramsString] = url.split('?')
    // 特殊处理一下 target 的 base
    if (base.startsWith('/')) {
      base = base.slice(1)
    }

    paramsString.split('&').forEach(paramPair => {
      let [key, value] = paramPair.split('=')
      if (!value) {
        result[key] = ''
      } else if (key === 'target') {
        result = Object.assign({}, result, parseUrl(decodeURIComponent(value)))
      } else if (wastedParams.includes(key)) {
        // 丢弃不要的参数
      } else {
        result[key] = value
      }
    })
    // 根据 path Dict 处理一下参数名
    const [pageType, pathValue] = Object.entries(pathDict).find(
      ([key, value]) => value === base,
    )
    switch (pageType) {
      case 'topic':
        break
      case 'page':
        if (result.id) {
          result.pageId = result.id
          delete result.id
        }
        break
      case 'article':
        result.docId = result.id
        delete result.id
        break
      case 'magazine':
        result.mid = result.id
        delete result.id
        break
      case 'quiz':
        if (result.publication) {
          result.publicationId = result.publication
          delete result.publication
        }
        break
      case 'lib':
        if (result.id) {
          result.libId = result.id
          delete result.id
        }
        break
    }
    if (!result.type) {
      result.pageType = pageType
    }
    return result
  }
  return parseUrl(path)
}

export function generateMinaCodeForPublication(pageType, publicationInfo, parameters = {}) {
  const { appId, id, appInfo } = publicationInfo
  const hasRelease = appInfo && appInfo.versions && appInfo.versions.release
  const hasPreview = appInfo && appInfo.versions && appInfo.versions.preview

  return generateMinaCode(pageType, {
    ...parameters,
    isPreview: !hasRelease && hasPreview,
    appId: (hasPreview || hasRelease) ? appId : null,
    publicationId: id,
  })
}
/**
 * 根据参数生成需要的小程序码
 * @param pageType 支持 page magazine article quiz lib preview
 * @param parameters {Object}
 * @param parameters.publicationId
 * @param parameters.mid
 * @param parameters.docId
 * @param parameters.pageId
 * @param parameters.libId
 * @param parameters.appId
 * @param parameters.isPrivate
 * @returns {string}
 */
export function generateMinaCode(pageType, parameters) {
  const {
    pubType,
    publicationId,
    mid,
    topicId,
    docId,
    pageId,
    libId,
    appId,
    isPrivate,
    isPreview, // 是否是预览版本
    isAudio,
    preview, // 预览参数（不是预览版本）
    previewTicket, // 预览 ticket（不是预览版本）
  } = parameters
  // console.log('generateMinaCode', pageType, parameters)
  const HOST = 'http://api.readland.cn'
  const $isContent = [
    'applet',
    'page',
    'magazine',
    'column',
    'article',
    'player',
    'preview',
    'topic',
    'overview',
  ].find(item => item === pageType)
  let PREFIX = $isContent ? `image2/publication/${publicationId}` : 'mina'
  let TYPE = 'wxacode'
  // 不再提供公共版本
  // let APP_ID = ((isContent, isPrivate) => {
  //   if (isPrivate) {
  //     return appId
  //   } else if (isContent) {
  //     return 'wx05790b1180642960'
  //   } else {
  //     return 'wx3e0a5430ef91b0e8'
  //   }
  // })($isContent, isPrivate)
  let APP_ID = isBITC() ? 'wxd07f35d4934129b4' : appId
  if (!APP_ID || APP_ID === 'wx05790b1180642960') {
    return imageBeforeBind
  }
  // TODO 是否要修改 Preview 的值
  const dict = {
    page: `${HOST}/${PREFIX}/${TYPE}/${APP_ID}/page${pageId ? `__id__${pageId}` : ''
      }${preview ? `__preview__1` : ''}`,
    overview: `${HOST}/${PREFIX}/${TYPE}/${APP_ID}/overview`,
    magazine: `${HOST}/${PREFIX}/${TYPE}/${APP_ID}/magazine${`__id__${mid}`}`,
    article: `${HOST}/${PREFIX}/${TYPE}/${APP_ID}/${isAudio ? 'player' : 'article'
      }${`__id__${docId}__mid__${mid}`}`,
    preview: `${HOST}/${PREFIX}/${TYPE}/${APP_ID}/preview${`__e__${previewTicket}`}`,
    podcast_preview: `${HOST}/${PREFIX}/${TYPE}/${APP_ID}/podcast_preview${`__e__${previewTicket}`}`,
    topic: `${HOST}/${PREFIX}/${TYPE}/${APP_ID}/topic${`__id__${topicId}`}`,
    quiz: isPrivate
      ? `${HOST}/${PREFIX}/${TYPE}/quiz/${APP_ID}`
      : `${HOST}/${PREFIX}/${TYPE}/quiz/${APP_ID}/publication__${publicationId}`,
    lib: `${HOST}/${PREFIX}/${TYPE}/lib/${APP_ID}/${libId}`,
  }
  if (pubType === 'podcast' && pageType === 'preview') {
    pageType = 'podcast_' + pageType
  }
  if (isPreview && !isBITC()) {
    const page = dict[pageType].split('/').slice(-1)[0]
    return `${HOST}/mina/qrcode/preview/${appId}/${page}`
  }
  return dict[pageType]
}

/**
 * 根据参数类型生成对应的海报
 * @param pageType 目前支持 article lib magazine
 * @param parameters
 * @param parameters.publicationId
 * @param parameters.mid
 * @param parameters.docId
 * @param parameters.pageId
 * @param parameters.libId
 * @param parameters.appId
 * @param parameters.isPrivate
 */
export function generatePoster(pageType, parameters) {
  const EMPTY_IMAGE = '/static/images/default/empty.png'
  const {
    publicationId,
    uid,
    mid,
    docId,
    libId,
    appId,
    isPrivate,
    topicId,
    isAudio,
    pubType,
  } = parameters
  const HOST = 'http://api.readland.cn'
  const $isContent = [
    'applet',
    'page',
    'magazine',
    'column',
    'article',
    'player',
    'preview',
    'topic',
  ].includes(pageType)
  const APP_ID = ((isContent, isPrivate) => {
    if (isPrivate) {
      return appId
    } else if (isContent) {
      return 'wx05790b1180642960'
    } else {
      return 'wx3e0a5430ef91b0e8'
    }
  })($isContent, isPrivate)
  const prefix = `/image2/share/`
  switch (pageType) {
    case 'lib':
      return `${HOST}${prefix}${APP_ID}/${pageType}/${libId}/s`
    case 'article':
      if (pubType === 'podcast') {
        return `${HOST}${prefix}${APP_ID}/article2/${docId}/s/pub__${publicationId}__uid__${uid ||
          ''}`
      }
      return `${HOST}${prefix}${APP_ID}/${isAudio ? 'player' : 'article'
        }/${docId}/s/pub__${publicationId}__mid__${mid}${uid ? `__uid__${uid}` : ''
        }`
    case 'magazine':
      return `${HOST}${prefix}${APP_ID}/${pageType}/${mid}/s/${publicationId ? `pub__${publicationId}` : ''
        }${uid ? `__uid__${uid}` : ''}`
    case 'topic':
      return `${HOST}${prefix}${APP_ID}/${pageType}/${topicId}/s/${publicationId ? `pub__${publicationId}` : ''
        }${uid ? `__uid__${uid}` : ''}`
    default:
      return EMPTY_IMAGE
  }
}
// 暂时只有 topic 可用
export function generatePromotionImage(pageType, parameters) {
  const EMPTY_IMAGE = '/static/images/default/empty.png'
  const {
    publicationId,
    uid,
    mid,
    docId,
    libId,
    appId,
    isPrivate,
    topicId,
    isAudio,
  } = parameters
  const HOST = 'http://api.readland.cn'
  const $isContent = [
    'applet',
    'page',
    'magazine',
    'column',
    'article',
    'player',
    'preview',
    'topic',
  ].includes(pageType)
  const APP_ID = ((isContent, isPrivate) => {
    if (isPrivate) {
      return appId
    } else if (isContent) {
      return 'wx05790b1180642960'
    } else {
      return 'wx3e0a5430ef91b0e8'
    }
  })($isContent, isPrivate)
  const prefix = `/image2/share/`
  switch (pageType) {
    case 'lib':
      return `${HOST}${prefix}${APP_ID}/${pageType}/${libId}/s`
    case 'article':
      return `${HOST}${prefix}${APP_ID}/${isAudio ? 'player' : 'article'
        }/${docId}/s/pub__${publicationId}__mid__${mid}${uid ? `__uid__${uid}` : ''
        }`
    case 'magazine':
      return `${HOST}${prefix}${APP_ID}/${pageType}/${mid}/s/${publicationId ? `pub__${publicationId}` : ''
        }${uid ? `__uid__${uid}` : ''}`
    case 'topic':
      return `${HOST}${prefix}${APP_ID}/${pageType}/${topicId}/b/${publicationId ? `pub__${publicationId}` : ''
        }${uid ? `__uid__${uid}` : ''}`
    default:
      return EMPTY_IMAGE
  }
}
// 随机生成 5 位数的 key
export function getCampaign() {
  const key = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let s = ''
  for (let i = 0; i < 5; i++) {
    // NOTICE: 为啥这里有 - 0 + 0 的操作？
    const index = parseInt(Math.random() * (key.length - 0) + 0)
    s += key[index]
  }
  return s
}

export function isAppOnly() {
  if (isKids() || isDuku() || isDayu() || isQingmang()) {
    return true
  }
  return false
}

export function isSupportModule(moduleName) {
  // 处理特殊 case
  if (isQingmang()) {
    if (['resource', 'article', 'author', 'column', 'candidate', 'commentNotes', 'setting'].indexOf(moduleName) >= 0) {
      return true
    }
    return false
  }
  // 默认不开启的功能
  if (['resource', 'article', 'author', 'column', 'candidate', 'setting'].indexOf(moduleName) >= 0) {
    return true
  }
  return false
}
